module.exports = __webpack_public_path__ + "static/media/volaille.6b0a1c8d.svg";